import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { GdnService } from "../../../services/gdn-service";

// import { Editor } from "react-draft-wysiwyg";

export const Gdnlist = (props) => {
  const { gdnID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  var bodyFormData = new FormData();

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    bodyFormData.append("supplier_name", values.supplier_name);
    bodyFormData.append("total_price", values.total_price);
    bodyFormData.append("comment", values.comment);
    bodyFormData.append("sent_date", values.sent_date);
    bodyFormData.append("status", values.status);
    try {
      await GdnService.gdnUpdate(gdnID, values);

      setSubmitLoading(true);
      notify("GDN successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
      //show error toast
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  supplier_name: props.supplier_name,
                  invoice_number: props.invoice_number,
                  total_price: props.total_price,
                  comment: props.comment,
                  sent_date: props.sent_date,
                  status: props.status,
                }}
                validationSchema={Yup.object().shape({
                  supplier_name: Yup.string().required("Required"),
                  comment: Yup.string()
                    .min(5, "description must have at least 5 characters")
                    .max(50, "description must have less than 25 characters"),
                  total_price: Yup.string().required("Required"),
                  sent_date: Yup.string().required("Required"),
                  status: Yup.string().required("Please, select an status"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                  setFieldValue,
                }) => (
                  <div>
                    <div className="form-row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Supplier Name</label>
                        <div className="input-group">
                          <input
                            name="supplier_name"
                            type="text"
                            className="form-control"
                            id="supplierNameid"
                            placeholder="Supplier Name"
                            required
                            readOnly
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.supplier_name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.supplier_name && errors.supplier_name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Invoice Number</label>
                        <div className="input-group">
                          <input
                            name="invoice_number"
                            type="text"
                            className="form-control"
                            id="invoiceNumberId"
                            placeholder="Invoice Number"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.invoice_number}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.invoice_number && errors.invoice_number}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Total Price</label>
                        <div className="input-group">
                          <input
                            name="total_price"
                            type="number"
                            className="form-control"
                            id="totalpriceid"
                            placeholder="Total Price"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.total_price}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.total_price && errors.total_price}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Dispatch Date</label>
                        <div className="input-group">
                          <input
                            name="sent_date"
                            type="date"
                            className="form-control"
                            id="sentDateid"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.sent_date}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.sent_date && errors.sent_date}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Comment</label>
                        <div className="input-group">
                          <input
                            name="comment"
                            type="text"
                            className="form-control"
                            id="commentid"
                            placeholder="Comment"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.comment}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.comment && errors.comment}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3 d-none">
                        <label htmlFor="validationCustom15">
                          Change Status
                        </label>
                        <div className="input-group">
                          <select
                            name="status"
                            className="form-control"
                            id="selectstatus"
                            required
                            disabled
                            value={values.status}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DISABLED">DEACTIVE</option>
                          </select>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.status && errors.status}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>

                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Save and Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gdnlist;
